import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ["en", "en-GB", "en-IE", "en-AU", "nl", "de", "es"],

  // Used when no locale matches
  defaultLocale: "en",

  // Default locale (en/US) has no prefix → /about-us
  // en-GB uses /gb prefix → /gb/about-us
  // Other locales use their code as prefix → /de/about-us
  localePrefix: {
    mode: "as-needed",
    prefixes: {
      "en-GB": "/gb",
      "en-IE": "/ie",
      "en-AU": "/au",
    },
  },

  // Page metadata owns canonical and hreflang links. Disabling middleware
  // alternates prevents unknown 404 paths from advertising localized variants.
  alternateLinks: false,
});

export type SupportedLocale = (typeof routing.locales)[number];

export function isSupportedLocale(locale: string): locale is SupportedLocale {
  return routing.locales.includes(locale as SupportedLocale);
}

export function resolveSupportedLocale(locale: string): SupportedLocale {
  return isSupportedLocale(locale) ? locale : routing.defaultLocale;
}
